import type { Directive } from "vue";

interface HoverElement extends HTMLElement {
  __hoverStart?: (evnt: Event) => void;
  __hoverEnd?: () => void;
}

const Hover: Directive<HTMLElement> = {
  beforeMount(el) {
    let timeOutInstance: ReturnType<typeof setTimeout> | null = null;
    const target = el as HoverElement;

    target.__hoverStart = (evnt: Event) => {
      if (!timeOutInstance) {
        timeOutInstance = setTimeout(() => {
          if (el.contains(evnt.target as Node)) {
            el.dispatchEvent(new Event("hover"));
            timeOutInstance = null;
          }
        }, 100);
      }
    };

    target.__hoverEnd = () => {
      if (timeOutInstance) {
        clearTimeout(timeOutInstance);
      }
      timeOutInstance = null;
    };

    el.addEventListener("mouseenter", target.__hoverStart, true);
    el.addEventListener("mouseleave", target.__hoverEnd, true);
  },

  unmounted(el) {
    const target = el as HoverElement;
    if (target.__hoverStart) {
      el.removeEventListener("mouseenter", target.__hoverStart, true);
    }
    if (target.__hoverEnd) {
      el.removeEventListener("mouseleave", target.__hoverEnd, true);
    }
    delete target.__hoverStart;
    delete target.__hoverEnd;
  }
};

export default Hover;
